import { useMemo } from 'react';

import axios, { Axios } from 'axios';

import { oimApiConfig } from '../../config';
import { useAuthorization } from '../../utils/Api';

export interface SearchRelationshipsOimContactParams {
  email?: string;
  phonePrimary?: string;
  phoneSecondary?: string;
}

export interface SearchRelationshipsContactParams {
  email?: string;
  phone?: string;
}

class RelationshipsApiProxyService {
  constructor(private readonly http: Axios) {}

  searchRelationshipsOimContact(params: SearchRelationshipsOimContactParams) {
    return this.http.get('/relationships-api-proxy/oim-contact', { params });
  }

  searchRelationshipsContact(params: SearchRelationshipsContactParams) {
    return this.http.get('/relationships-api-proxy/contact', { params });
  }
}

export const useRelationshipsApiProxyService = () => {
  const http = axios.create({
    baseURL: oimApiConfig.apiBaseUrl,
  });

  useAuthorization(http);

  return useMemo(() => new RelationshipsApiProxyService(http), [http]);
};
